import React from "react";
import style from "./style.module.sass";
import selectTriangle from "./assets/selectTriangle.svg";
import selectTriangleBW from "./assets/selectTriangleBW.svg"
import selectTriangleDark from "./assets/selectTriangleDark.svg"
import closeModalWhite from "./assets/Icon-ionic-ios-close-circle.svg";
import closeModalBW from "./assets/Icon-ionic-ios-close-circle-bw.svg"
import {NavLink} from "react-router-dom";
import person from "./assets/Icon-material-person.svg";
import personBw from "./assets/Icon-material-person-bw.svg"
import personDark from "./assets/Icon-material-person-dark.svg"
//import modalNotifyIcon from "./assets/Component-4–1.svg";
import logout from "./assets/Icon-open-account-logout.svg";
import logoutBw from "./assets/Icon-open-account-logout-bw.svg"
import logoutDark from "./assets/Icon-open-account-logout-dark.svg"
import {useTheme} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import config from "../../../config"


function DropdownUser({openPersonalModalWin, setOpenPersonalModalWin}) {
    const {theme: {bgColors, borderColors, colors}} = useTheme();
    const {t} = useTranslation();
    // get reducers
    const user = useSelector(state => state.userData.user);
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)

    const selectTriangleImage = themeState === config.THEMES_MODES.LIGHT ? selectTriangle : (themeState === config.THEMES_MODES.CONTRAST_LIGHT ? selectTriangleBW : selectTriangleDark)
    const closeModalImage = themeState === config.THEMES_MODES.LIGHT ? closeModalWhite : (themeState === config.THEMES_MODES.CONTRAST_LIGHT ? closeModalBW : closeModalWhite)
    const personImage = themeState === config.THEMES_MODES.LIGHT ? person : (themeState === config.THEMES_MODES.CONTRAST_LIGHT ? personBw : personDark)
    const logoutImage = themeState === config.THEMES_MODES.LIGHT ? logout : (themeState === config.THEMES_MODES.CONTRAST_LIGHT ? logoutBw : logoutDark)

    return (

        <div style={{
            backgroundColor: bgColors.bgPrimary500, transform: openPersonalModalWin ? "translateY(10px)" :
                "translateY(-1000px)", zIndex: 9
        }}
             className={style.select}>
            <img className={style.triangle} src={selectTriangleImage} alt=""/>
            <div style={{color: colors.colorPrimary100, borderColor: borderColors.borderPrimary700}} onClick={() =>
                setOpenPersonalModalWin(false)}
                 className={`d-flex align-items-center pb-4 ${style.options}`}>
                <img className={`mr-2 ml-0`} src={closeModalImage} alt=""/>
                <p className={`m-0`}>{user['user_name']}</p>
            </div>
            <NavLink style={{color: colors.colorPrimary100, borderColor: borderColors.borderPrimary700}} to="/profile"
                     exact tabIndex={openPersonalModalWin ? config.tabIndexes.preferences : -1} title={t("accessibility_header_preferences")}
                     className={`d-flex
        align-items-center
        ${style.options}`}>
                <img src={personImage} alt="" />
                <p className={`m-0`}>{t("Preferences")}</p>
            </NavLink>
            <NavLink style={{color: colors.colorPrimary100, borderColor: borderColors.borderPrimary700}}
                     to="/logout"
                     exact
                     tabIndex={openPersonalModalWin ? config.tabIndexes.logout : -1}
                     title={t("accessibility_header_logout")}
                     className={`d-flex
        align-items-center ${style.options}`}>
                <img src={logoutImage} alt=""/>
                <p className={`m-0`}>{t("Logout")}</p>
            </NavLink>
        </div>
    );
}

export default DropdownUser;